"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/ban-types */
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var Card_1 = __importDefault(require("../../../../../common/Card/Card"));
var FlatList_1 = __importDefault(require("../../../../../common/FlatList/FlatList"));
// import Modal from "../../../../../common/Modal/Modal";
var org_hook_1 = require("../../../../../context/OrgContext/org.hook");
var user_hook_1 = require("../../../../../context/UserContext/user.hook");
var general_1 = require("../../../../../lib/general");
var ServiceCenterForm_1 = __importDefault(require("./ServiceCenterForm"));
var react_modal_1 = __importDefault(require("react-modal"));
var Button_1 = __importDefault(require("../../../../../common/Button/Button"));
var icons_1 = __importDefault(require("../../../../../theme/icons"));
var ServiceCenter = function (_a) {
    var data = _a.data, setCenters = _a.setCenters;
    var _b = (0, react_i18next_1.useTranslation)(), t = _b.t, i18n = _b.i18n;
    var organization = (0, org_hook_1.useOrg)().organization;
    var user = (0, user_hook_1.useUser)().user;
    var history = (0, react_router_dom_1.useHistory)();
    var _c = (0, react_1.useState)(false), isOpen = _c[0], setIsOpen = _c[1];
    var renderChild = function (item) {
        var _a;
        return (item === null || item === void 0 ? void 0 : item.id) ? (react_1.default.createElement(Card_1.default, { text: (0, general_1.isJsonWithAvailableLang)(item.name, i18n.language, t), iconUrl: true, 
            // icon={item?.icon_web}
            icon: (0, general_1.generateMediaLink)(item === null || item === void 0 ? void 0 : item.icon, organization === null || organization === void 0 ? void 0 : organization.id, (_a = user === null || user === void 0 ? void 0 : user.user_info) === null || _a === void 0 ? void 0 : _a.address_country), onClick: function () {
                history.push("/admin/service", { center: item });
            } })) : (
        // <Modal
        //   title="add_service_center"
        //   triggerButton={
        //     <Card
        //       key={"addnew"}
        //       text={isJsonWithAvailableLang(item.name, i18n.language, t)}
        //       iconUrl={false}
        //       icon={item?.id ? "organization" : "plus"}
        //       // onClick={() => onClick(item)}
        //     />
        //   }
        // >
        //   <ServiceCenterForm list={data} setCenters={setCenters} />
        // </Modal>
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Card_1.default, { key: "addnew", text: (0, general_1.isJsonWithAvailableLang)(item.name, i18n.language, t), iconUrl: false, icon: (item === null || item === void 0 ? void 0 : item.id) ? "organization" : "plus", onClick: function () { return setIsOpen(true); } }),
            react_1.default.createElement(react_modal_1.default, { isOpen: isOpen, onRequestClose: function () {
                    setIsOpen(false);
                }, contentLabel: "Add Category Modal", style: {
                    content: {
                        top: "50%",
                        left: "50%",
                        right: "auto",
                        bottom: "auto",
                        marginRight: "-50%",
                        transform: "translate(-50%, -50%)",
                        width: "75%",
                        height: "75%",
                    },
                }, ariaHideApp: false },
                react_1.default.createElement("div", { style: {
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                    } },
                    react_1.default.createElement("h2", null, t("add_service_center")),
                    react_1.default.createElement("div", { style: {
                            display: "flex",
                            justifyContent: "space-between",
                            marginTop: "1rem",
                            marginBottom: "1rem",
                        } },
                        react_1.default.createElement(Button_1.default, { className: "modal-button", onClick: function () {
                                setIsOpen(false);
                            }, icon: react_1.default.createElement(icons_1.default, { name: "cancel", className: "icon", height: 20, width: 20 }) }))),
                react_1.default.createElement(ServiceCenterForm_1.default, { list: data, setCenters: setCenters }))));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(FlatList_1.default, { data: __spreadArray([{ name: "addNew" }], data, true), renderItem: renderChild, numberOfColumn: 4 })));
};
exports.default = ServiceCenter;
